import React from "react";
import styled from "styled-components";

export const DescriptionCell = ({
  children,
  maxHeight = "100px",
  align = "center",
}) => {
  return (
    <Container $maxHeight={maxHeight} $align={align}>
      <Content>{children}</Content>
    </Container>
  );
};

const Container = styled.div`
  max-height: ${(props) => props.$maxHeight};
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  text-align: ${(props) => props.$align};

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a0aec0;
  }
`;

const Content = styled.div`
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
`;
